export enum TreeMatchDirection
{
	Up = 0,
	Down = 1
}